<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers /></el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Page Header -->
							<div class="page_header">
								Measure Training Effectiveness
							</div>

							<div class="page_main">
								<div class="training-effect-page">
									<el-form
										ref="form"
										:model="form"
										:rules="formRules"
										label-position="top"
										class="page-form"
									>
										<el-form-item label="Training Item Identifier" class="full-width-item">
											<div class="gray-input">
												{{ form.item_name || "/" }}
											</div>
										</el-form-item>
									
										<el-form-item label="Description" class="full-width-item">
											<div class="gray-input">
												{{ form.item_description || "/" }}
											</div>
										</el-form-item>
									
										<div class="btn_el">
											<div class="tips">
												<span class="warning-label">
													Note:
												</span>
												Training effectiveness is intended to measure the overall quality of the most recent training conducted for a specific item, rather than the competency of individual trainees.
											</div>
										</div>
									
										<el-form-item label="Training Effectiveness Evaluation Guidelines" class="full-width-item">
											<div class="gray-input">
												{{ form.effectiveness_evaluation_guidelines || "/" }}
											</div>
										</el-form-item>
									
										<el-form-item label="Is the Training Effective?" prop="training_effective">
											<el-select
												v-model="form.training_effective"
												placeholder="Please select"
												class="full-width"
											>
												<el-option label="Yes" :value="1" />
												<el-option label="No" :value="2" />
											</el-select>
										</el-form-item>
									
										<el-form-item label="Description" prop="description">
											<el-input
												v-model="form.description"
												type="textarea"
												:rows="5"
												placeholder="Please enter a description of the training effectiveness."
											/>
										</el-form-item>
									
										<div class="btn_el">
											<div class="tips">
												To upload files containing records related to measuring training effectiveness, click the
												<strong>"Add Training Effectiveness Record Attachment"</strong> button.
											</div>
										</div>
									
										<div class="file-panel">
											<div class="panel-header">
												<div class="panel-title">
													Training Effectiveness Record Attachments
												</div>
									
												<div class="panel-actions">
													<el-input
														v-model="attachmentKeyword"
														placeholder="Search"
														clearable
														class="search-input"
													>
														<i slot="prefix" class="el-input__icon el-icon-search"></i>
													</el-input>
												</div>
											</div>
									
											<el-table
												:data="filteredAttachments"
												border
												class="file-table"
												header-cell-class-name="table-header-cell"
												empty-text="No training effectiveness record attachments"
											>
												<el-table-column label="Actions" width="80" align="center">
													<template slot-scope="scope">
														<el-button size="mini" type="primary" @click="handleEdit(scope.row)">
															Edit
														</el-button>
													</template>
												</el-table-column>
									
												<el-table-column label="Description" min-width="220">
													<template slot-scope="scope">
														<span>{{ scope.row.description }}</span>
													</template>
												</el-table-column>
									
												<el-table-column label="File Name" min-width="420">
													<template slot-scope="scope">
														<el-link type="primary" :underline="true">
															<a :href="scope.row.image_info.url" target="_blank">
																{{ scope.row.image_info.name }}
															</a>
														</el-link>
													</template>
												</el-table-column>
									
												<el-table-column label="Actions" width="80" align="center">
													<template slot-scope="scope">
														<el-button size="mini" type="danger" @click="handleDelete(scope.row)">
															Delete
														</el-button>
													</template>
												</el-table-column>
											</el-table>
									
											<div class="action-row">
												<el-button
													type="primary"
													size="medium"
													@click="handleAssignOtherUser"
												>
													Add Training Effectiveness Record Attachment
												</el-button>
											</div>
										</div>
									
										<div class="footer-actions">
											<el-button type="primary" @click="handleSave('form')">
												Save for Later
											</el-button>
									
											<el-button type="primary" @click="handleSaveAndContinue('form')">
												Save and Continue to Sign
											</el-button>
									
											<el-button @click="handleBack">
												Withdraw
											</el-button>
									
											<el-button @click="handleCancel">
												Cancel
											</el-button>
										</div>
									</el-form>
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--添加培训效果记录附件-->
		<!-- Add Training Effectiveness Record Attachment -->
		<el-dialog
			:title="dialogVisibleTitle"
			:visible.sync="dialogVisible"
			width="50%"
		>
			<div class="save_box">
				<div class="form_box">
					<div style="padding-bottom:20px;font-weight:bold;font-size:16px">
						Please complete the following information.
					</div>
		
					<el-form
						ref="ruleForm"
						:model="ruleForm"
						:rules="rules"
						label-position="top"
						class="upload-form"
					>
						<el-form-item label="Description" prop="description">
							<el-input
								v-model="ruleForm.description"
								type="textarea"
								:rows="3"
								resize="none"
								placeholder="Please enter a description."
							/>
						</el-form-item>
		
						<el-form-item>
							<div class="upload-doc-wrapper">
								<div class="upload-title required-title">
									<span>File to Upload</span>
									<span class="upload-limit">(Maximum 10 MB)</span>
								</div>
		
								<div class="upload-box" style="position:relative;">
									<el-upload
										ref="uploadBox"
										class="doc-upload"
										action="/api/trainSuperviseFile"
										name="files"
										:headers="{ token: userToken }"
										:show-file-list="false"
										:before-upload="beforeAvatarUpload"
										:on-success="handleAvatarSuccess"
										:limit="1"
										:with-credentials="true"
									>
										<el-button size="medium" class="select-btn">
											Select File
										</el-button>
									</el-upload>
		
									<div class="file-name" :class="{ placeholder: !fileName }">
										{{ fileName || "No file selected" }}
		
										<span
											v-if="fileName"
											style="position:absolute;right:20px;top:12px;cursor:pointer;color:#f00;"
											@click="delFile"
										>
											Remove
										</span>
									</div>
								</div>
							</div>
						</el-form-item>
					</el-form>
				</div>
		
				<div class="btn_box">
					<van-button
						class="btn_el"
						type="default"
						round
						@click="dialogVisible = false"
					>
						Cancel
					</van-button>
		
					<van-button
						class="btn_el"
						round
						color="linear-gradient(to right, #7BC1FF, #4886FF)"
						@click="submitForm('ruleForm')"
					>
						Confirm
					</van-button>
				</div>
			</div>
		</el-dialog>
		
		<!-- Signature -->
		<el-dialog
			:title="dialogTitle"
			:visible.sync="dialogVisible1"
			width="30%"
		>
			<div class="save_box">
				<div class="form_box">
					<div style="padding-bottom:20px;font-weight:bold;font-size:16px">
						Please complete the following information.
					</div>
		
					<el-form
						:model="signForm"
						:rules="signRules"
						ref="ruleForm1"
						label-width="0px"
					>
						<div class="input_el">
							<div class="tit" :class="{ required: isRemarkRequired }">
								Comment
							</div>
		
							<el-form-item prop="remark">
								<el-input
									type="textarea"
									:rows="3"
									v-model="signForm.remark"
									placeholder="Please enter."
									clearable
								/>
							</el-form-item>
						</div>
		
						<div class="input_el">
							<div class="tit required">
								Password
							</div>
		
							<el-form-item prop="signature">
								<el-input
									v-model="signForm.signature"
									placeholder="Please enter."
									clearable
									show-password
								/>
							</el-form-item>
						</div>
					</el-form>
				</div>
		
				<div class="btn_box">
					<van-button
						class="btn_el"
						type="default"
						round
						@click="dialogVisible1 = false"
					>
						Cancel
					</van-button>
		
					<van-button
						class="btn_el"
						round
						color="linear-gradient(to right, #7BC1FF, #4886FF)"
						@click="submitForm1('ruleForm1')"
					>
						Sign
					</van-button>
				</div>
			</div>
		</el-dialog>
		<!--签名弹框-->
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import {
	ApplyDetail,
	trainEditSupervise,
	trainSuperviseFile,
	trainSuperviseFileAdd,
	trainSuperviseFileEdit,
	trainSuperviseFileDel,
	trainSuperviseComplete
}
from "@/api/trainManage/myTrain/index";
import {
	resourcesApplyWithdraw
} from '@/api/docManage/changeRequest/index';
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
import myTask from "./my-task.vue";
import unclaimedTask from "./unclaimed-task.vue";
import md5 from 'js-md5';
export default {
	components: {
		headers,
		slider,
		myTask,
		unclaimedTask,
	},
	data() {
		return {
			isLoading: true,
			dialogTitle: "",
			dialogVisible: false,
			dialogVisible1: false,
			dialogVisibleTitle: '',
			fileName: "",
			selectedFile: null,
			form: {
				id: '',
				item_name: "",
				item_description: "",
				effectiveness_evaluation_guidelines: "",
				training_effective: '',
				description: ''
			},
			formRules: {
				training_effective: [{ required: true, message: "Please select", trigger: "change" }],
				description: [{ required: true, message: "Please enter", trigger: "blur" }],
			},
			attachmentKeyword: "",
			attachments: [],
			userToken: localStorage.getItem("userToken"),
			signForm: {
				remark: "",
				signature: "",
			},
			signRules: {
				remark: [{ required: true, message: "Please enter", trigger: "blur" }],
				signature: [{ required: true, message: "Please enter", trigger: "blur" }],
			},
			ruleForm: {
				id: '',
				description: "",
				fileUrl: "",
			},
			rules: {
				description: [{ required: true, message: "Please enter", trigger: "blur" }],
			},
		};
	},
	created() {
		let that = this;
		that.oid = that.$route.query.oid;
	},
	mounted() {
		let that = this;
		//请求详情
		ApplyDetail({ id: that.oid }).then(res => {
			if(res.code == 200) {
				that.form.id = res.data.id;
				that.form.item_name = res.data.item_name;
				that.form.description = res.data.description;
				that.form.item_description = res.data.item_description;
				that.form.effectiveness_evaluation_guidelines = res.data.effectiveness_evaluation_guidelines;
				that.form.training_effective = res.data.training_effective != 0 ? Number(res.data.training_effective) : '';
				that.attachments = res.data.file_list;
				// console.log(res.data);
				// that.handleAssignOtherUser();
			}
			that.isLoading = false;
		});
	},
	computed: {
		filteredAttachments() {
			const keyword = (this.attachmentKeyword || "").trim().toLowerCase();
			if (!keyword) return this.attachments;
			return this.attachments.filter((item) => {
				return ((item.desc && item.desc.toLowerCase().includes(keyword)) || (item.fileName && item.fileName.toLowerCase().includes(keyword)));
			});
		},
		isRemarkRequired() {
			let that = this;
			switch (that.dialogTitle) {
				case "Sign an evaluation of training effectiveness":
				return true;
				case "Withdrawal of evaluation of training effectiveness":
				return true;
			}
		},
	},
	methods: {
		handleAvatarSuccess(res, file) {
			let that = this;
			if (!file && !res) return;
			that.selectedFile = res.data.id;
			that.fileName = res.data.name;
			that.$toast.clear();
		},
		beforeAvatarUpload(file) {
			let that = this;
			const maxSize = 10 * 1024 * 1024; // 10MB
			const isLt100M = file.size <= maxSize;
			if(!isLt100M) {
				that.$message.error("Uploaded files cannot exceed 10 MB in size.");
				return false;
			}
			that.$toast.loading({ duration: 0, forbidClick: true });
		},
		//保存稍后
		handleSave(formName) {
			let that = this;
			that.$refs[formName].validate((valid) => {
				if(valid) {
					if(that.attachments.length == 0) { that.$message.warning("Please add the training effectiveness record as an attachment first."); return false; }
					let ids = that.attachments.map(item => item.id).join(',');
					that.$toast.loading({ duration: 0, forbidClick: true });
					// 编辑培训效果
					trainEditSupervise({
						id: that.form.id,
						training_effective: that.form.training_effective,
						description: that.form.description,
						supervise_files: ids
					}).then(res => {
						if(res.code == 200) {
							that.$toast.clear();
							that.$message.success('Operation successful');
							setTimeout(() => {
								window.location.reload();
							}, 800);
						}
					});
				}else {
					return false;
				}
			});
		},
		//保存并继续签名
		handleSaveAndContinue(formName) {
			let that = this;
			that.$refs[formName].validate((valid) => {
				if(valid) {
					if(that.attachments.length == 0) { that.$message.warning("Please add the training effectiveness record as an attachment first."); return false; }
					that.dialogTitle = "Sign an evaluation of training effectiveness";
					that.dialogVisible1 = true;
				}else {
					return false;
				}
			});
		},
		handleBack() {
			let that = this;
			that.dialogTitle = "Withdrawal of evaluation of training effectiveness";
			that.dialogVisible1 = true;
		},
		handleCancel() {
			let that = this;
			that.$router.back();
		},
		//添加培训效果记录文件
		handleAssignOtherUser() {
			let that = this;
			that.dialogVisibleTitle = 'Add training effectiveness record attachment';
			that.dialogVisible = true;
		},
		//编辑培训效果记录文件
		handleEdit(row) {
			let that = this;
			that.dialogVisibleTitle = 'Edit training effectiveness record attachments';
			that.ruleForm.id = row.id;
			that.ruleForm.description = row.description;
			that.selectedFile = row.image_info.id;
			that.fileName = row.image_info.name;
			that.dialogVisible = true;
		},
		handleDelete(row) {
			let that = this;
			that.$confirm('Delete the file?', 'Confirmation', {
				type: 'warning'
			}).then(() => {
				that.$toast.loading({ duration: 0, forbidClick: true });
				trainSuperviseFileDel({
					id: row.id
				}).then(res => {
					if(res.code == 200) {
						that.$toast.clear();
						that.$message.success('Operation successful');
						that.attachments = [];
						setTimeout(() => {
							that.attachments = res.data;
						}, 300);
					}
				});
			}).catch(() => {});
		},
		//上传文件弹框删除文件
		delFile() {
			let that = this;
			that.ruleForm.description = '';
			that.selectedFile = '';
			that.fileName = '';
			that.$refs.uploadBox.clearFiles();
		},
		//上传文件确定
		submitForm(formName) {
			let that = this;
			that.$refs[formName].validate((valid) => {
				if(valid) {
					if(!that.selectedFile) { that.$message.warning("Please upload the file."); return false; }
					that.$toast.loading({ duration: 0, forbidClick: true });
					if(that.dialogVisibleTitle == 'Add training effectiveness record attachment') {
						//添加
						trainSuperviseFileAdd({
							supervise_id: that.form.id,
							description: that.ruleForm.description,
							image_id: that.selectedFile
						}).then(res => {
							if(res.code == 200) {
								that.$toast.clear();
								that.$message.success('Operation successful');
								that.delFile();
								that.attachments = [];
								setTimeout(() => {
									that.dialogVisible = false;
									that.attachments = res.data;
								}, 800);
							}
						});
					}else if(that.dialogVisibleTitle = 'Edit training effectiveness record attachments') {
						//编辑
						trainSuperviseFileEdit({
							id: that.ruleForm.id,
							supervise_id: that.form.id,
							description: that.ruleForm.description,
							image_id: that.selectedFile
						}).then(res => {
							if(res.code == 200) {
								that.$toast.clear();
								that.$message.success('Operation successful');
								that.delFile();
								that.attachments = [];
								setTimeout(() => {
									that.dialogVisible = false;
									that.attachments = res.data;
								}, 800);
							}
						});
					}
				}else {
					return false;
				}
			});
		},
		submitForm1(formName) {
			let that = this;
			that.$refs[formName].validate((valid) => {
				if(valid) {
					if(that.dialogTitle == 'Sign an evaluation of training effectiveness') {
						//培训效果审批完成
						let ids = that.attachments.map(item => item.id).join(',');
						that.$toast.loading({ duration: 0, forbidClick: true });
						// 编辑培训效果
						trainEditSupervise({
							id: that.form.id,
							training_effective: that.form.training_effective,
							description: that.form.description,
							supervise_files: ids
						}).then(res => {
							if(res.code == 200) {
								trainSuperviseComplete({
									id: that.form.id,
									training_comments: that.signForm.remark,
									signature: md5(that.signForm.signature+'AiisoQms2026')
								}).then(res2 => {
									if(res2.code == 200) {
										that.$toast.clear();
										that.$message.success('Operation successful');
										setTimeout(() => {
											that.$router.back();
										}, 800);
									}
								});
							}
						});
					}else if(that.dialogTitle == 'Withdrawal of evaluation of training effectiveness') {
						//请求撤回
						that.$toast.loading({ duration: 0, forbidClick: true });
						resourcesApplyWithdraw({
							id: that.oid,
							remark: that.signForm.remark,
							signature: md5(that.signForm.signature+'AiisoQms2026')
						}).then(res => {
							if(res.code == 200) {
								that.$toast.clear();
								that.$message.success('Operation successful');
								setTimeout(() => {
									that.$router.back();
								}, 800);
							}
						});
					}
				}else {
					return false;
				}
			});
		},
	},
};
</script>

<style lang="less" scoped>
.save_box {
  .btn_box {
    text-align: right;
    .btn_el {
      margin-left: 10px;
      padding: 12px 24px;
      .van-button__text {
        font-size: 16px;
      }
    }
  }
  .form_box {
    .input_el {
      .tit {
        padding-bottom: 5px;
        font-size: 14px;
        color: #333333;
      }
      .required::before {
        content: "*";
        color: red;
        margin-right: 2px;
      }
    }
  }
}
//主要内容
.main_main {
  .page_main {
    padding: 18px 20px;
    .btn_el {
      margin: 10px 0 20px 0;
      .tips {
        padding: 6px 8px;
        background-color: #ffb1001a;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  //页头
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }
}
</style>
<style scoped>
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}
.main_box .main_main {
  position: relative;
  min-height: calc(100% - 0px);
  max-height: auto;
  background-color: #fafafa;
}
.el-header,
.el-main {
  padding: 0;
}

.training-effect-page {
  padding: 12px;
  min-height: 100vh;
  box-sizing: border-box;
}

.full-width {
  width: 100%;
}

.full-width-item {
  margin-top: 8px;
}

.gray-input {
  background: #e9ecef;
  border: 1px solid #cfd5db;
  color: #2f343b;
  border-radius: 8px;
  padding-left: 15px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}

.file-panel {
  background: #fff;
  border: 1px solid #dcdfe6;
  margin-top: 40px;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px 0;
}

.panel-title {
  font-size: 18px;
  font-weight: 700;
  color: #222;
  line-height: 32px;
}

.panel-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.search-input {
  width: 220px;
}

.file-table {
  width: 100%;
  margin-top: 8px;
}

.action-row {
  padding: 10px 10px;
}

.action-row .el-button {
  margin-right: 8px;
  margin-bottom: 8px;
}

.upload-doc-wrapper {
  width: 100%;
  margin-bottom: 40px;
  box-sizing: border-box;
}

.upload-title {
  font-size: 16px;
  color: #333;
  margin-bottom: 14px;
  font-weight: 500;
}

.required-title {
  position: relative;
  padding-left: 10px;
}

.required-title::before {
  content: "*";
  position: absolute;
  left: 0;
  top: 3px;
  color: #f56c6c;
  font-size: 15px;
}

.upload-limit {
  color: #666;
  font-weight: 400;
}

.upload-box {
  display: flex;
  align-items: center;
  width: 100%;
  height: 44px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  overflow: hidden;
  background: #f5f7fa;
}

.doc-upload {
  flex-shrink: 0;
}

.file-name {
  flex: 1;
  height: 44px;
  line-height: 44px;
  padding: 0 16px;
  font-size: 15px;
  color: #333;
  background: #f5f7fa;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
}

.file-name.placeholder {
  color: #999;
}

.footer-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 32px;
}

::v-deep .el-form-item__label {
  padding-bottom: 8px;
  font-size: 14px;
  line-height: 20px;
  color: #2f343b;
  font-weight: 700;
}
</style>

